export const ATLAS_ASSET_TOKEN_LOCAL_STORAGE_KEY = "atlas-asset-access-token";
